import { Injectable } from '@angular/core';
import axios from "axios";
import { urls } from '../../../environments/environment_url';
import { Language, LanguageNGK } from 'src/app/interfaces/language.interface';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    private BASE_URL = urls.BASE_URL;

    constructor(){
    }

    async getLanguageService(){
        return await axios.get(this.BASE_URL+'/public/language/get-language');
    }
    
    async getLanguageNGKService(){
        return await axios.get(this.BASE_URL+'/public/language/get-language-products');
    }

    /**
     * Metodo que traduce un texto.
     * Busca coincidencias en el objeto languageData ya sean ingles o español.
     * Valida cual es el idioma seleccionado y devuelve el texto correspondiente.
     * @param currentText Recibe el texto a traducir.
     * @param currentLang Recibe el idioma seleccionado.
     * @param languageData  Recibe el objeto que contiene todos los registros del idioma.
     * @returns Devuelve el texto que coincide en el objeto del idioma.
     */
    findWordInLanguages(currentText: string, currentLang: any, languageData: Language[]) {
        let translatedText;
        let result = languageData.find(lang => (lang.english && lang.english.trim() === currentText.trim()) || (lang.spanish && lang.spanish.trim() === currentText.trim()));
        if (!result) {
            return translatedText;
        }
        if (currentLang == 'english') {
            translatedText = result.english;
        } else {
            translatedText = result.spanish;
        }
        return translatedText;
    }

    /**
     * Metodo que traduce un texto pero viene del language de NGK.
     * Busca coincidencias en el objeto languageData ya sean ingles o español.
     * Valida cual es el idioma seleccionado y devuelve el texto correspondiente.
     * @param currentText Recibe el texto a traducir.
     * @param currentLang Recibe el idioma seleccionado.
     * @param languageData  Recibe el objeto que contiene todos los registros del idioma.
     * @returns Devuelve el texto que coincide en el objeto del idioma.
     */
     findWordInLanguagesNGK(currentText: string, languageData: LanguageNGK[]) {
        let result = languageData.find(lang => (lang.english && lang.english.trim() == currentText.trim()) 
        || (lang.spanish && lang.spanish.trim() == currentText.trim()));

        if (!result) {
            return currentText;
        }
        return result;
    }

    findWordInLanguagesByFlag(flag: string, currentLang: any, languageData: Language[]) {
        let translatedText;
        let result = languageData.find(lang => lang.flag && lang.flag.trim() === flag.trim());
        if (!result) {
            return translatedText;
        }
        if (currentLang == 'english') {
            translatedText = result.english;
        } else {
            translatedText = result.spanish;
        }
        return translatedText;
    }

    /* private normalizeText(currentText: string): string {
        arrayVowels.forEach(vowel => {
            let regex = RegExp(vowel.value, 'g');
            currentText = currentText.replace(regex, vowel.valueNormalized);
        });
        return currentText;
    } */
}